import React, {useState} from 'react'
import {UserModel} from '../../auth/core/_models'
import {FuturiskFreeHealthCheckupModel} from './FuturiskFreeHealthCheckupModel'

type Props = {
  className: string
  title: string
  description: string
  avatar?: string
  link: string | undefined
  currentUser?: UserModel | null
}

const FuturiskFreeHealthCheckupWidget: React.FC<Props> = ({title, description, currentUser}) => {
  const [modalShow, setModalShow] = useState(false)

  return (
    <div style={{padding: 0}}>
      <div
        className='hoverable shadow-sm overflow-hidden'
        role='button'
        onClick={() => setModalShow(true)}
        style={{
          cursor: 'pointer',
          borderRadius: 8,
          background: 'linear-gradient(135deg, #169dc2 0%, #2f8fce 100%)',
        }}
      >
        <div
          className='d-flex flex-column flex-xl-row align-items-center justify-content-start gap-10'
          style={{padding: '1rem 1rem', minHeight: 130}}
        >
          <div className='d-flex flex-column flex-lg-row align-items-center gap-4'>
            <div
              style={{
                background: '#ffffff',
                borderRadius: 28,
                padding: '1rem 1.5rem',
                minWidth: 280,
                boxShadow: '0 10px 24px rgba(15, 23, 42, 0.14)',
              }}
            >
              <div style={{color: '#0ea5e9', fontWeight: 700, fontSize: '0.88rem', letterSpacing: '0.08em'}}>
                FUTURISK
              </div>
              <div style={{color: '#111827', fontWeight: 800, fontSize: '1.9rem', lineHeight: 1.05}}>
                Free Health Checkup
              </div>
            </div>

            <div
              style={{
                width: 76,
                height: 88,
                borderRadius: 20,
                background: 'rgba(255,255,255,0.16)',
                padding: '14px 12px',
                boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.24)',
              }}
            >
              <div style={{width: 30, height: 8, borderRadius: 999, background: '#ffffff', margin: '0 auto 12px'}} />
              {[0, 1, 2].map((rowIndex) => (
                <div key={rowIndex} className='d-flex align-items-center gap-2' style={{marginBottom: rowIndex === 2 ? 0 : 10}}>
                  <div style={{width: 10, height: 10, borderRadius: 3, background: '#86efac'}} />
                  <div style={{flex: 1, height: 6, borderRadius: 999, background: 'rgba(255,255,255,0.88)'}} />
                </div>
              ))}
            </div>
          </div>

          <div style={{maxWidth: 610, color: '#ffffff', textAlign: 'left'}}>
            <div style={{fontSize: '1.95rem', fontWeight: 500, lineHeight: 1.25, marginBottom: '0.45rem'}}>
              {title}
            </div>
            <div style={{fontSize: '1.12rem', lineHeight: 1.45, opacity: 0.96}}>{description}</div>
            <div className='d-flex flex-wrap gap-2 mt-3'>
              <span className='badge bg-light text-dark'>No payment</span>
              <span className='badge bg-light text-dark'>One booking only</span>
              <span className='badge bg-light text-dark'>6:00 AM to 7:00 PM</span>
            </div>
          </div>
        </div>
      </div>

      <FuturiskFreeHealthCheckupModel
        show={modalShow}
        handleClose={() => setModalShow(false)}
        currentUser={currentUser || undefined}
      />
    </div>
  )
}

export {FuturiskFreeHealthCheckupWidget}